export const en = {
  'members.title': 'Members',
  'members.description': 'Everyone who has ever joined the gym.',
  'members.new': 'New member',
  'members.searchPlaceholder': 'Search by name, email, phone or member number',
  'members.memberStatus': 'Member status',
  'members.anyStatus': 'Any status',
  'members.membershipStatus': 'Membership status',
  'members.anyMembership': 'Any membership',
  'members.tagFilter': 'Tags',
  'members.anyTag': 'Any tag',
  'members.tagsChosen.one': '{count} tag',
  'members.tagsChosen.other': '{count} tags',
  'members.tagFilterHint': 'Members with any of the tags chosen',
  'members.clearTags': 'Clear tags',
  'members.segment': 'Segment',
  'members.allMembers': 'All members',
  'members.exportCsv': 'Export CSV',
  'members.exportFailed': 'The export failed',
  'members.tags': 'Tags',
  'members.selectAll': 'Select every member on this page',
  'members.selectMember': 'Select {name}',
  'members.selected.one': '{count} selected',
  'members.selected.other': '{count} selected',
  'members.bulkTag': 'Tag',
  'members.bulkUntag': 'Remove tag',
  'members.chooseTag': 'Choose a tag',
  'members.bulkDone.one': 'Tags changed for {count} member',
  'members.bulkDone.other': 'Tags changed for {count} members',
  'members.clearSelection': 'Clear selection',
  'members.membershipFilter.PENDING': 'Membership pending',
  'members.membershipFilter.ACTIVE': 'Membership active',
  'members.membershipFilter.PAUSED': 'Membership frozen',
  'members.membershipFilter.EXPIRED': 'Membership expired',
  'members.membershipFilter.CANCELLED': 'Membership cancelled',
  'members.membershipFilter.SUSPENDED': 'Membership suspended',
  'members.number': 'Member number',
  'members.noMatch': 'No members match',
  'members.noMatchHint': 'Try a different search or clear the filters.',
  'members.empty': 'No members yet',
  'members.emptyHint': 'Add your first member to get started.',
  'members.joined': 'Joined',
  'members.created': 'Member created',
  'members.newDescription': 'Create a member record. You can sell them a membership right after.',
  'members.create': 'Create member',
  'members.field.firstName': 'First name',
  'members.field.lastName': 'Last name',
  'members.field.dateOfBirth': 'Date of birth',
  'members.field.gender': 'Gender',
  'members.field.nationalId': 'National ID',
  'members.field.locale': 'Preferred language',
  'members.field.notes': 'Notes',
  'members.emailRequiredForLogin': 'Required to create a login',
  'members.createLogin': 'Create a login',
  'members.createLoginHint': 'Lets the member sign in to the member area and book classes. If the email has no account yet, we send them a link to set their password.',
  'memberDetail.deleted': 'Member deleted',
  'memberDetail.subtitle': 'Member #{number} · joined {date}',
  'memberDetail.profile': 'Profile',
  'memberDetail.login': 'Login',
  'memberDetail.tab.overview': 'Overview',
  'memberDetail.tab.memberships': 'Memberships',
  'memberDetail.tab.credentials': 'Credentials',
  'memberDetail.tab.payments': 'Payments',
  'memberDetail.tab.bookings': 'Bookings',
  'memberDetail.tab.access': 'Access',
  'memberDetail.tab.texts': 'Texts',
  'memberDetail.deleteTitle': 'Delete this member?',
  'memberDetail.deleteDescription': 'Their memberships, bookings and history will be removed. This cannot be undone.',
  'memberDetail.deleteConfirm': 'Delete member',
  'memberDetail.loginNone': 'None',
  'memberDetail.loginEnabled': 'Enabled',
  'memberDetail.passwordNotSet': 'Password not set',
  'memberDetail.awaitingConfirmation': 'Waiting for the account holder to confirm',
  'memberDetail.resendInvitation': 'Resend invitation',
  'memberDetail.resend': 'Resend',
  'memberDetail.updated': 'Member updated',
  'memberDetail.editTitle': 'Edit member',
  'memberDetail.saveChanges': 'Save changes',
  'memberDetail.blockedHint': 'Blocked members are denied at the door.',
  'memberDetail.smsNotifications': 'Texts about classes and membership',
  'memberDetail.smsNotificationsHint': 'Cancelled or changed classes, a membership about to end or a failed renewal, and the sign-in link also go to the phone by SMS, when the gym has an SMS account.',
  'memberDetail.emailOffers': 'Agreed to offers by email',
  'memberDetail.emailOffersHint': 'Tick only when the member said yes. Each change is kept with your name and the time, as proof of consent.',
  'memberDetail.smsOffers': 'Agreed to offers by SMS',
  'memberDetail.smsOffersHint': 'Tick only when the member said yes. Each change is kept with your name and the time, as proof of consent.',
  'memberOverview.flag.EXPIRES_SOON': 'Expires within a week',
  'memberOverview.flag.NO_ACTIVE_MEMBERSHIP': 'No running membership',
  'memberOverview.flag.PAUSED': 'Membership frozen',
  'memberOverview.flag.UNPAID_ORDER': 'Unpaid order',
  'memberOverview.flag.NO_CARD': 'No card or QR',
  'memberOverview.flag.DENIED_RECENTLY': 'Denied at the door in the last 24h',
  'memberOverview.flag.VISIT_LIMIT_NEAR': 'Almost out of visits',
  'memberOverview.expired': 'Expired',
  'memberOverview.paused': 'Frozen',
  'memberOverview.awaitingPayment': 'Awaiting payment',
  'memberOverview.openEnded': 'Open-ended',
  'memberOverview.lastDay': 'Last day',
  'memberOverview.membership': 'Membership',
  'memberOverview.planUntil': '{plan} · until {date}',
  'memberOverview.noneOnRecord': 'None on record',
  'memberOverview.shareLeft': 'Share of the membership left',
  'memberOverview.visits30': 'Visits, last 30 days',
  'memberOverview.perWeek': '≈ {count}/week',
  'memberOverview.rightNow': 'Right now',
  'memberOverview.visitsUsedOf': '{used} of {limit} visits used',
  'memberOverview.visitsThisMonth': '{count} visits this month',
  'memberOverview.inside': 'Inside',
  'memberOverview.notInside': 'Not inside',
  'memberOverview.paidLifetime': 'Paid, lifetime',
  'memberOverview.paidAt': 'Paid at {branches}',
  'memberOverview.lastPaid': 'Last paid {date}',
  'memberOverview.noPayments': 'No payments yet',
  'memberOverview.nextClass': 'Next class',
  'memberOverview.classStats': '{attended} attended, {missed} missed in 30 days',
  'memberOverview.noneBooked': 'None booked',
  'memberOverview.thingsToKnow': 'Things to know',
  'memberOverview.dayVisits.one': '{date}: {count} visit',
  'memberOverview.dayVisits.other': '{date}: {count} visits',
  'memberOverview.dailyVisitsChart': 'Daily visits over the last 30 days, peak {peak} a day',
  'memberOverview.dailyVisits': 'Daily visits',
  'memberOverview.visits': 'Visits',
  'memberOverview.visitsHint': "Each bar is one day in the gym's time zone.",
  'memberOverview.recentActivity': 'Recent activity',
  'memberOverview.nothingYet': 'Nothing yet.',
  'memberOverview.classOn': 'Class on {date}',
  'memberOverview.timeline.entered': 'Entered',
  'memberOverview.timeline.left': 'Left',
  'memberOverview.timeline.denied': 'Denied',
  'memberOverview.timeline.deniedBecause': 'Denied: {reason}',
  'memberOverview.timeline.payment.PENDING': 'Payment pending {amount}',
  'memberOverview.timeline.payment.AUTHORIZED': 'Payment authorized {amount}',
  'memberOverview.timeline.payment.PAID': 'Paid {amount}',
  'memberOverview.timeline.payment.FAILED': 'Payment failed {amount}',
  'memberOverview.timeline.payment.CANCELLED': 'Payment cancelled {amount}',
  'memberOverview.timeline.payment.REFUNDED': 'Refunded {amount}',
  'memberOverview.timeline.payment.PARTIALLY_REFUNDED': 'Paid {amount}, partly refunded',
  'memberOverview.timeline.booking.BOOKED': 'Booked {className}',
  'memberOverview.timeline.booking.CANCELLED': 'Cancelled {className}',
  'memberOverview.timeline.booking.ATTENDED': 'Attended {className}',
  'memberOverview.timeline.booking.NO_SHOW': 'Missed {className}',
  'memberOverview.timeline.booking.WAITLISTED': 'Waitlisted for {className}',
  'memberOverview.timeline.membership.ACTIVATE': 'Membership activated',
  'memberOverview.timeline.membership.RENEW': 'Membership renewed',
  'memberOverview.timeline.membership.PAUSE': 'Membership frozen',
  'memberOverview.timeline.membership.RESUME': 'Membership unfrozen',
  'memberOverview.timeline.membership.EXPIRE': 'Membership expired',
  'memberOverview.timeline.membership.CANCEL': 'Membership cancelled',
  'memberOverview.timeline.membership.SUSPEND': 'Membership suspended',
  'memberOverview.timeline.membership.UNSUSPEND': 'Suspension lifted',
  'memberOverview.timeline.membership.DELETE': 'Membership deleted',
  'memberOverview.timeline.membership.RESTORE': 'Membership restored',
  'enum.memberTimeline.ACCESS': 'Door',
  'enum.memberTimeline.PAYMENT': 'Payment',
  'enum.memberTimeline.BOOKING': 'Class',
  'enum.memberTimeline.MEMBERSHIP': 'Membership',
  'memberActivity.noPayments': 'No payments',
  'memberActivity.paymentsAt': 'Payments taken at {branches}. Online payments and payments taken at other branches are not listed.',
  'memberActivity.noPaymentsHint': 'Payments appear here once the member buys or is charged for a plan.',
  'memberActivity.description': 'Description',
  'memberActivity.amount': 'Amount',
  'memberActivity.provider': 'Provider',
  'memberActivity.noBookings': 'No bookings',
  'memberActivity.noBookingsHint': 'Class bookings made by or for this member show up here.',
  'memberActivity.class': 'Class',
  'memberActivity.session': 'Session',
  'memberActivity.trainer': 'Trainer',
  'memberActivity.noAccess': 'No access events',
  'memberActivity.noAccessHint': 'Check-ins at readers and turnstiles are listed here.',
  'memberActivity.when': 'When',
  'memberActivity.reader': 'Reader',
  'memberActivity.direction': 'Direction',
  'memberActivity.result': 'Result',
  'memberActivity.allDays': 'All days',
  'memberActivity.noAccessOnDays': 'No taps on these days',
  'memberActivity.noAccessOnDaysHint': 'Pick other days on the calendar or above, or show all days.',
  'memberActivity.mapTitle': 'Visits and memberships',
  'memberActivity.visitsInYear.one': '{count} visit in {year}',
  'memberActivity.visitsInYear.other': '{count} visits in {year}',
  'memberActivity.daysUncovered.one': '{count} day without a membership',
  'memberActivity.daysUncovered.other': '{count} days without a membership',
  'memberActivity.year': 'Year',
  'memberActivity.mapLabel': "Visits in {year}: {count}. Use the arrow keys to move between days and Enter to list that day's taps.",
  'memberCards.intro': 'Cards, wristbands and codes this member presents at the door.',
  'memberCards.add': 'Add credential',
  'memberCards.empty': 'No credentials',
  'memberCards.emptyHint': 'Issue a card or code so the member can check in.',
  'memberCards.type': 'Type',
  'memberCards.value': 'Value',
  'memberCards.label': 'Label',
  'memberCards.lastUsed': 'Last used',
  'memberCards.never': 'Never',
  'memberCards.disable': 'Disable',
  'memberCards.markLost': 'Mark lost',
  'memberCards.reactivate': 'Reactivate',
  'memberCards.updated': 'Credential updated',
  'memberCards.added': 'Credential added',
  'memberCards.addConfirm': 'Add',
  'memberCards.valueHint': 'Card UID, QR payload or PIN. Scan the card into this field if you have a desk reader.',
  'memberCards.labelHint': 'Optional, e.g. “Blue card”',
  'memberMemberships.intro': 'Current and past memberships for this member.',
  'memberMemberships.sell': 'Sell membership',
  'memberMemberships.give': 'Give without payment',
  'memberMemberships.empty': 'No memberships yet',
  'memberMemberships.emptyHint': 'Sell a plan to give this member access.',
  'memberMemberships.plan': 'Plan',
  'memberMemberships.starts': 'Starts',
  'memberMemberships.ends': 'Ends',
  'memberMemberships.visits': 'Visits',
  'memberMemberships.autoRenew': 'auto-renew',
  'memberMemberships.pausedSince': 'since {date}',
  'memberMemberships.given': 'Membership given',
  'memberMemberships.pickPlan': 'Pick a plan',
  'memberMemberships.giveDescription': '{name} gets the plan now and no payment is recorded. Only for memberships the gym gives away; the reason goes to the audit log.',
  'memberMemberships.giveConfirm': 'Give membership',
  'memberMemberships.giveReasonPlaceholder': 'e.g. competition prize, family of staff',
  'memberMemberships.start': 'Start',
  'memberMemberships.startHint': 'Leave empty to start now.',
  'membershipActions.activate.label': 'Activate without payment',
  'membershipActions.activate.title': 'Activate without payment',
  'membershipActions.activate.description': 'Starts the membership now and no payment is recorded. Only for a membership the gym gives away; the reason goes to the audit log. To charge for it, sell the plan instead.',
  'membershipActions.renew.label': 'Renew without payment',
  'membershipActions.renew.title': 'Renew without payment',
  'membershipActions.renew.description': 'Adds another plan period and resets the visits, and no payment is recorded. To charge for it, sell the plan instead.',
  'membershipActions.suspend.label': 'Suspend',
  'membershipActions.suspend.title': 'Suspend membership',
  'membershipActions.suspend.description': 'Blocks access until the membership is unsuspended.',
  'membershipActions.unsuspend.label': 'Unsuspend',
  'membershipActions.unsuspend.title': 'Unsuspend membership',
  'membershipActions.unsuspend.description': 'Restores access for this member.',
  'membershipActions.delete.label': 'Delete',
  'membershipActions.delete.title': 'Delete this membership?',
  'membershipActions.delete.description': 'For a membership entered by mistake. It leaves the member, the lists, the reports and the door, and can be restored for 7 days. A paid membership is refunded first, from Payments.',
  'membershipActions.delete.reasonPlaceholder': 'For example: entered twice',
  'membershipActions.deleted': 'Membership deleted',
  'members.addMembership': 'Add a membership for {name}',
  'membershipActions.cancel.label': 'Cancel',
  'membershipActions.cancel.title': 'Cancel membership',
  'membershipActions.cancel.description': 'This cannot be undone. The member keeps their history.',
  'membershipActions.updated': 'Membership updated',
  'membershipActions.history': 'History',
  'membershipActions.menu': 'Membership actions',
  'membershipActions.freeze': 'Freeze',
  'membershipActions.unfreeze': 'Unfreeze',
  'membershipActions.freezeTitle': 'Freeze membership',
  'membershipActions.freezeDescription.one': '{plan} · frozen {count} time so far',
  'membershipActions.freezeDescription.other': '{plan} · frozen {count} times so far',
  'membershipActions.freezeFrom': 'From',
  'membershipActions.freezeUntil': 'Until',
  'membershipActions.freezeReasonDefault': "At the member's request",
  'membershipActions.frozen': 'Membership frozen',
  'membershipActions.freezeScheduled': 'Freeze scheduled from {date}',
  'membershipActions.unfreezeTitle': 'Unfreeze membership?',
  'membershipActions.unfreezeDescription': 'The freeze ends today and the days it lasted are added to the end date.',
  'membershipActions.unfrozen': 'Membership unfrozen',
  'membershipActions.historyTitle': 'Membership history',
  'membershipActions.noHistory': 'No history yet',
  'enum.membershipStatus.PAUSED': 'Frozen',
  'enum.membershipTransition.ACTIVATE': 'Activate',
  'enum.membershipTransition.RENEW': 'Renew',
  'enum.membershipTransition.PAUSE': 'Freeze',
  'enum.membershipTransition.RESUME': 'Unfreeze',
  'enum.membershipTransition.EXPIRE': 'Expire',
  'enum.membershipTransition.CANCEL': 'Cancel',
  'enum.membershipTransition.SUSPEND': 'Suspend',
  'enum.membershipTransition.UNSUSPEND': 'Unsuspend',
  'enum.membershipTransition.DELETE': 'Delete',
  'enum.membershipTransition.RESTORE': 'Restore',
  'memberPhoto.take': 'Take photo',
  'memberPhoto.upload': 'Upload',
  'memberPhoto.takeTitle': 'Take a photo',
  'memberPhoto.takeHint': 'Ask the member to face the camera. The photo is shown at the desk and at the turnstile.',
  'memberPhoto.capture': 'Capture',
  'memberPhoto.noCamera': 'This browser cannot use a camera. Upload a photo instead.',
  'memberPhoto.cameraDenied': 'The camera could not be opened. Allow camera access in the browser, or upload a photo instead.',
  'memberPhoto.saved': 'Photo saved',
  'memberPhoto.remove': 'Remove photo',
  'memberPhoto.missing': 'No photo yet',
  'memberPhoto.uploadFailed': 'The member was saved, but the photo did not upload. Add it from the member’s page.',
};

export const ka: Record<keyof typeof en, string> = {
  'members.title': 'წევრები',
  'members.description': 'ყველა, ვინც ოდესმე გაწევრიანებულა დარბაზში.',
  'members.new': 'ახალი წევრი',
  'members.searchPlaceholder': 'მოძებნეთ სახელით, ელფოსტით, ტელეფონით ან წევრის ნომრით',
  'members.memberStatus': 'წევრის სტატუსი',
  'members.anyStatus': 'ნებისმიერი სტატუსი',
  'members.membershipStatus': 'აბონემენტის სტატუსი',
  'members.anyMembership': 'ნებისმიერი აბონემენტი',
  'members.tagFilter': 'ტეგები',
  'members.anyTag': 'ნებისმიერი ტეგი',
  'members.tagsChosen.one': '{count} ტეგი',
  'members.tagsChosen.other': '{count} ტეგი',
  'members.tagFilterHint': 'წევრები არჩეული ტეგებიდან ნებისმიერით',
  'members.clearTags': 'ტეგების გასუფთავება',
  'members.segment': 'სეგმენტი',
  'members.allMembers': 'ყველა წევრი',
  'members.exportCsv': 'CSV-ის ექსპორტი',
  'members.exportFailed': 'ექსპორტი ვერ მოხერხდა',
  'members.tags': 'ტეგები',
  'members.selectAll': 'ამ გვერდის ყველა წევრის მონიშვნა',
  'members.selectMember': '{name} — მონიშვნა',
  'members.selected.one': 'მონიშნულია {count}',
  'members.selected.other': 'მონიშნულია {count}',
  'members.bulkTag': 'ტეგის მინიჭება',
  'members.bulkUntag': 'ტეგის მოხსნა',
  'members.chooseTag': 'აირჩიეთ ტეგი',
  'members.bulkDone.one': 'ტეგები შეიცვალა {count} წევრს',
  'members.bulkDone.other': 'ტეგები შეიცვალა {count} წევრს',
  'members.clearSelection': 'მონიშვნის გაუქმება',
  'members.membershipFilter.PENDING': 'აბონემენტი ელოდება გადახდას',
  'members.membershipFilter.ACTIVE': 'აბონემენტი აქტიურია',
  'members.membershipFilter.PAUSED': 'აბონემენტი გაყინულია',
  'members.membershipFilter.EXPIRED': 'აბონემენტს ვადა გაუვიდა',
  'members.membershipFilter.CANCELLED': 'აბონემენტი გაუქმებულია',
  'members.membershipFilter.SUSPENDED': 'აბონემენტი შეჩერებულია',
  'members.number': 'წევრის ნომერი',
  'members.noMatch': 'წევრები ვერ მოიძებნა',
  'members.noMatchHint': 'სცადეთ სხვა ძებნა ან გაასუფთავეთ ფილტრები.',
  'members.empty': 'წევრები ჯერ არ არის',
  'members.emptyHint': 'დასაწყებად დაამატეთ პირველი წევრი.',
  'members.joined': 'გაწევრიანდა',
  'members.created': 'წევრი შეიქმნა',
  'members.newDescription': 'შექმენით წევრის ჩანაწერი. ამის შემდეგ მაშინვე შეგიძლიათ აბონემენტის გაყიდვა.',
  'members.create': 'წევრის შექმნა',
  'members.field.firstName': 'სახელი',
  'members.field.lastName': 'გვარი',
  'members.field.dateOfBirth': 'დაბადების თარიღი',
  'members.field.gender': 'სქესი',
  'members.field.nationalId': 'პირადი ნომერი',
  'members.field.locale': 'სასურველი ენა',
  'members.field.notes': 'შენიშვნები',
  'members.emailRequiredForLogin': 'სავალდებულოა ანგარიშის შესაქმნელად',
  'members.createLogin': 'ანგარიშის შექმნა',
  'members.createLoginHint': 'წევრი შეძლებს წევრის კაბინეტში შესვლას და ვარჯიშებზე ჩაწერას. თუ ამ ელფოსტით ანგარიში ჯერ არ არსებობს, გავუგზავნით ბმულს პაროლის დასაყენებლად.',
  'memberDetail.deleted': 'წევრი წაიშალა',
  'memberDetail.subtitle': 'წევრი #{number} · გაწევრიანდა {date}',
  'memberDetail.profile': 'პროფილი',
  'memberDetail.login': 'ანგარიში',
  'memberDetail.tab.overview': 'მიმოხილვა',
  'memberDetail.tab.memberships': 'აბონემენტები',
  'memberDetail.tab.credentials': 'ბარათები და კოდები',
  'memberDetail.tab.payments': 'გადახდები',
  'memberDetail.tab.bookings': 'ჯავშნები',
  'memberDetail.tab.access': 'შესვლების ისტორია',
  'memberDetail.tab.texts': 'SMS-ები',
  'memberDetail.deleteTitle': 'წავშალოთ ეს წევრი?',
  'memberDetail.deleteDescription': 'წაიშლება მისი აბონემენტები, ჯავშნები და ისტორია. ამის დაბრუნება შეუძლებელია.',
  'memberDetail.deleteConfirm': 'წევრის წაშლა',
  'memberDetail.loginNone': 'არ აქვს',
  'memberDetail.loginEnabled': 'ჩართულია',
  'memberDetail.passwordNotSet': 'პაროლი არ არის დაყენებული',
  'memberDetail.awaitingConfirmation': 'ელოდება ანგარიშის მფლობლის დადასტურებას',
  'memberDetail.resendInvitation': 'მოწვევის ხელახლა გაგზავნა',
  'memberDetail.resend': 'ხელახლა გაგზავნა',
  'memberDetail.updated': 'წევრის მონაცემები შეინახა',
  'memberDetail.editTitle': 'წევრის რედაქტირება',
  'memberDetail.saveChanges': 'ცვლილებების შენახვა',
  'memberDetail.blockedHint': 'დაბლოკილ წევრებს შესასვლელთან უარი ეთქმებათ.',
  'memberDetail.smsNotifications': 'SMS ვარჯიშებისა და აბონემენტის შესახებ',
  'memberDetail.smsNotificationsHint': 'გაუქმებული ან შეცვლილი ვარჯიში, ვადაგასული ან ვერგანახლებული აბონემენტი და შესვლის ბმული ტელეფონზეც მოვა SMS-ით, თუ დარბაზს SMS ანგარიში აქვს.',
  'memberDetail.emailOffers': 'დათანხმდა შეთავაზებებს ელფოსტით',
  'memberDetail.emailOffersHint': 'მონიშნეთ მხოლოდ მაშინ, როცა წევრი დათანხმდა. ყოველი ცვლილება ინახება თქვენი სახელითა და დროით, როგორც თანხმობის დადასტურება.',
  'memberDetail.smsOffers': 'დათანხმდა შეთავაზებებს SMS-ით',
  'memberDetail.smsOffersHint': 'მონიშნეთ მხოლოდ მაშინ, როცა წევრი დათანხმდა. ყოველი ცვლილება ინახება თქვენი სახელითა და დროით, როგორც თანხმობის დადასტურება.',
  'memberOverview.flag.EXPIRES_SOON': 'ვადა ერთ კვირაში იწურება',
  'memberOverview.flag.NO_ACTIVE_MEMBERSHIP': 'მოქმედი აბონემენტი არ აქვს',
  'memberOverview.flag.PAUSED': 'აბონემენტი გაყინულია',
  'memberOverview.flag.UNPAID_ORDER': 'გადაუხდელი შეკვეთა',
  'memberOverview.flag.NO_CARD': 'ბარათი ან QR კოდი არ აქვს',
  'memberOverview.flag.DENIED_RECENTLY': 'ბოლო 24 საათში შესასვლელთან უარი მიიღო',
  'memberOverview.flag.VISIT_LIMIT_NEAR': 'ვიზიტები თითქმის ამოიწურა',
  'memberOverview.expired': 'ვადაგასული',
  'memberOverview.paused': 'გაყინული',
  'memberOverview.awaitingPayment': 'ელოდება გადახდას',
  'memberOverview.openEnded': 'უვადო',
  'memberOverview.lastDay': 'ბოლო დღე',
  'memberOverview.membership': 'აბონემენტი',
  'memberOverview.planUntil': '{plan} · {date}-მდე',
  'memberOverview.noneOnRecord': 'ჩანაწერი არ არის',
  'memberOverview.shareLeft': 'აბონემენტის დარჩენილი ნაწილი',
  'memberOverview.visits30': 'ვიზიტები ბოლო 30 დღეში',
  'memberOverview.perWeek': '≈ {count} კვირაში',
  'memberOverview.rightNow': 'ახლა',
  'memberOverview.visitsUsedOf': 'გამოყენებულია {used} ვიზიტი {limit}-დან',
  'memberOverview.visitsThisMonth': 'ამ თვეში {count} ვიზიტი',
  'memberOverview.inside': 'შიგნითაა',
  'memberOverview.notInside': 'შიგნით არ არის',
  'memberOverview.paidLifetime': 'სულ გადახდილი',
  'memberOverview.paidAt': 'გადახდილი აქ: {branches}',
  'memberOverview.lastPaid': 'ბოლო გადახდა {date}',
  'memberOverview.noPayments': 'გადახდები ჯერ არ არის',
  'memberOverview.nextClass': 'შემდეგი ვარჯიში',
  'memberOverview.classStats': '30 დღეში: {attended} დასწრება, {missed} გაცდენა',
  'memberOverview.noneBooked': 'ჯავშანი არ არის',
  'memberOverview.thingsToKnow': 'საყურადღებო',
  'memberOverview.dayVisits.one': '{date}: {count} ვიზიტი',
  'memberOverview.dayVisits.other': '{date}: {count} ვიზიტი',
  'memberOverview.dailyVisitsChart': 'ვიზიტები დღეების მიხედვით ბოლო 30 დღეში, მაქსიმუმ {peak} დღეში',
  'memberOverview.dailyVisits': 'ვიზიტები დღეების მიხედვით',
  'memberOverview.visits': 'ვიზიტები',
  'memberOverview.visitsHint': 'თითო სვეტი ერთი დღეა, დარბაზის სასაათო სარტყლის მიხედვით.',
  'memberOverview.recentActivity': 'ბოლო აქტივობა',
  'memberOverview.nothingYet': 'ჯერ არაფერია.',
  'memberOverview.classOn': 'ვარჯიში {date}',
  'memberOverview.timeline.entered': 'შემოვიდა',
  'memberOverview.timeline.left': 'გავიდა',
  'memberOverview.timeline.denied': 'არ შეუშვა',
  'memberOverview.timeline.deniedBecause': 'არ შეუშვა: {reason}',
  'memberOverview.timeline.payment.PENDING': 'გადახდა მოლოდინშია: {amount}',
  'memberOverview.timeline.payment.AUTHORIZED': 'გადახდა ავტორიზებულია: {amount}',
  'memberOverview.timeline.payment.PAID': 'გადაიხადა {amount}',
  'memberOverview.timeline.payment.FAILED': 'გადახდა ვერ შესრულდა: {amount}',
  'memberOverview.timeline.payment.CANCELLED': 'გადახდა გაუქმდა: {amount}',
  'memberOverview.timeline.payment.REFUNDED': 'დაუბრუნდა {amount}',
  'memberOverview.timeline.payment.PARTIALLY_REFUNDED': 'გადაიხადა {amount}, ნაწილი დაუბრუნდა',
  'memberOverview.timeline.booking.BOOKED': 'დაჯავშნა: {className}',
  'memberOverview.timeline.booking.CANCELLED': 'ჯავშანი გააუქმა: {className}',
  'memberOverview.timeline.booking.ATTENDED': 'დაესწრო: {className}',
  'memberOverview.timeline.booking.NO_SHOW': 'არ გამოცხადდა: {className}',
  'memberOverview.timeline.booking.WAITLISTED': 'მოლოდინის სიაშია: {className}',
  'memberOverview.timeline.membership.ACTIVATE': 'აბონემენტი გააქტიურდა',
  'memberOverview.timeline.membership.RENEW': 'აბონემენტი გაგრძელდა',
  'memberOverview.timeline.membership.PAUSE': 'აბონემენტი გაიყინა',
  'memberOverview.timeline.membership.RESUME': 'გაყინვა მოიხსნა',
  'memberOverview.timeline.membership.EXPIRE': 'აბონემენტს ვადა გაუვიდა',
  'memberOverview.timeline.membership.CANCEL': 'აბონემენტი გაუქმდა',
  'memberOverview.timeline.membership.SUSPEND': 'აბონემენტი შეჩერდა',
  'memberOverview.timeline.membership.UNSUSPEND': 'შეჩერება მოიხსნა',
  'memberOverview.timeline.membership.DELETE': 'აბონემენტი წაიშალა',
  'memberOverview.timeline.membership.RESTORE': 'აბონემენტი აღდგა',
  'enum.memberTimeline.ACCESS': 'შესვლა',
  'enum.memberTimeline.PAYMENT': 'გადახდა',
  'enum.memberTimeline.BOOKING': 'ვარჯიში',
  'enum.memberTimeline.MEMBERSHIP': 'აბონემენტი',
  'memberActivity.noPayments': 'გადახდები არ არის',
  'memberActivity.paymentsAt': 'გადახდები, მიღებული აქ: {branches}. ონლაინ და სხვა ფილიალებში მიღებული გადახდები აქ არ ჩანს.',
  'memberActivity.noPaymentsHint': 'გადახდები აქ გამოჩნდება, როცა წევრი პაკეტს შეიძენს ან მისგან თანხა ჩამოიჭრება.',
  'memberActivity.description': 'აღწერა',
  'memberActivity.amount': 'თანხა',
  'memberActivity.provider': 'პროვაიდერი',
  'memberActivity.noBookings': 'ჯავშნები არ არის',
  'memberActivity.noBookingsHint': 'აქ ჩანს ვარჯიშების ჯავშნები, რომლებიც ამ წევრმა ან მისთვის გააკეთეს.',
  'memberActivity.class': 'ვარჯიში',
  'memberActivity.session': 'სესია',
  'memberActivity.trainer': 'ტრენერი',
  'memberActivity.noAccess': 'შესვლები არ არის',
  'memberActivity.noAccessHint': 'აქ ჩანს შესვლები წამკითხველებსა და ტურნიკეტებზე.',
  'memberActivity.when': 'დრო',
  'memberActivity.reader': 'წამკითხველი',
  'memberActivity.direction': 'მიმართულება',
  'memberActivity.result': 'შედეგი',
  'memberActivity.allDays': 'ყველა დღე',
  'memberActivity.noAccessOnDays': 'ამ დღეებში შესვლები არ ყოფილა',
  'memberActivity.noAccessOnDaysHint': 'აირჩიეთ სხვა დღეები კალენდარზე ან ზემოთ, ან აჩვენეთ ყველა დღე.',
  'memberActivity.mapTitle': 'ვიზიტები და აბონემენტები',
  'memberActivity.visitsInYear.one': '{year} წელს {count} ვიზიტი',
  'memberActivity.visitsInYear.other': '{year} წელს {count} ვიზიტი',
  'memberActivity.daysUncovered.one': '{count} დღე აბონემენტის გარეშე',
  'memberActivity.daysUncovered.other': '{count} დღე აბონემენტის გარეშე',
  'memberActivity.year': 'წელი',
  'memberActivity.mapLabel': 'ვიზიტები {year} წელს: {count}. დღეებს შორის გადასასვლელად გამოიყენეთ ისრები, ხოლო დღის შესვლების სანახავად — Enter.',
  'memberCards.intro': 'ბარათები, სამაჯურები და კოდები, რომლებსაც ეს წევრი შესასვლელთან იყენებს.',
  'memberCards.add': 'ბარათის ან კოდის დამატება',
  'memberCards.empty': 'ბარათები და კოდები არ არის',
  'memberCards.emptyHint': 'მიეცით წევრს ბარათი ან კოდი, რომ შესვლა შეძლოს.',
  'memberCards.type': 'ტიპი',
  'memberCards.value': 'მნიშვნელობა',
  'memberCards.label': 'დასახელება',
  'memberCards.lastUsed': 'ბოლოს გამოყენებული',
  'memberCards.never': 'არასდროს',
  'memberCards.disable': 'გამორთვა',
  'memberCards.markLost': 'დაკარგულად მონიშვნა',
  'memberCards.reactivate': 'ხელახლა გააქტიურება',
  'memberCards.updated': 'ბარათის ან კოდის სტატუსი შეიცვალა',
  'memberCards.added': 'ბარათი ან კოდი დაემატა',
  'memberCards.addConfirm': 'დამატება',
  'memberCards.valueHint': 'ბარათის UID, QR კოდის შიგთავსი ან PIN. თუ მიმღებზე წამკითხველი გაქვთ, ბარათი პირდაპირ ამ ველში დაასკანერეთ.',
  'memberCards.labelHint': 'არასავალდებულო, მაგ. „ლურჯი ბარათი“',
  'memberMemberships.intro': 'ამ წევრის მიმდინარე და წინა აბონემენტები.',
  'memberMemberships.sell': 'აბონემენტის გაყიდვა',
  'memberMemberships.give': 'უფასოდ გაცემა',
  'memberMemberships.empty': 'აბონემენტები ჯერ არ არის',
  'memberMemberships.emptyHint': 'გაყიდეთ პაკეტი, რომ წევრს დაშვება ჰქონდეს.',
  'memberMemberships.plan': 'პაკეტი',
  'memberMemberships.starts': 'იწყება',
  'memberMemberships.ends': 'მთავრდება',
  'memberMemberships.visits': 'ვიზიტები',
  'memberMemberships.autoRenew': 'ავტომატური გაგრძელება',
  'memberMemberships.pausedSince': '{date}-დან',
  'memberMemberships.given': 'აბონემენტი გაიცა',
  'memberMemberships.pickPlan': 'აირჩიეთ პაკეტი',
  'memberMemberships.giveDescription': '{name} პაკეტს ახლავე მიიღებს და გადახდა არ დაფიქსირდება. მხოლოდ იმ აბონემენტისთვის, რომელსაც დარბაზი უფასოდ გასცემს; მიზეზი აუდიტის ჟურნალში ჩაიწერება.',
  'memberMemberships.giveConfirm': 'აბონემენტის გაცემა',
  'memberMemberships.giveReasonPlaceholder': 'მაგ. კონკურსის პრიზი, თანამშრომლის ოჯახის წევრი',
  'memberMemberships.start': 'დაწყება',
  'memberMemberships.startHint': 'დატოვეთ ცარიელი, რომ ახლავე დაიწყოს.',
  'membershipActions.activate.label': 'გააქტიურება გადახდის გარეშე',
  'membershipActions.activate.title': 'გააქტიურება გადახდის გარეშე',
  'membershipActions.activate.description': 'აბონემენტი ახლავე დაიწყება და გადახდა არ დაფიქსირდება. მხოლოდ იმ აბონემენტისთვის, რომელსაც დარბაზი უფასოდ გასცემს; მიზეზი აუდიტის ჟურნალში ჩაიწერება. საფასურის ასაღებად პაკეტი გაყიდეთ.',
  'membershipActions.renew.label': 'გაგრძელება გადახდის გარეშე',
  'membershipActions.renew.title': 'გაგრძელება გადახდის გარეშე',
  'membershipActions.renew.description': 'აბონემენტს კიდევ ერთი პერიოდი დაემატება და ვიზიტები განულდება, გადახდა კი არ დაფიქსირდება. საფასურის ასაღებად პაკეტი გაყიდეთ.',
  'membershipActions.suspend.label': 'შეჩერება',
  'membershipActions.suspend.title': 'აბონემენტის შეჩერება',
  'membershipActions.suspend.description': 'დაშვება დაიბლოკება, სანამ შეჩერება არ მოიხსნება.',
  'membershipActions.unsuspend.label': 'შეჩერების მოხსნა',
  'membershipActions.unsuspend.title': 'აბონემენტის შეჩერების მოხსნა',
  'membershipActions.unsuspend.description': 'წევრს დაშვება აღუდგება.',
  'membershipActions.delete.label': 'წაშლა',
  'membershipActions.delete.title': 'წავშალოთ ეს აბონემენტი?',
  'membershipActions.delete.description': 'შეცდომით შეყვანილი აბონემენტისთვის. ის ქრება წევრიდან, სიებიდან, ანგარიშებიდან და შესასვლელიდან, და 7 დღის განმავლობაში აღდგენა შეიძლება. გადახდილი აბონემენტის თანხა ჯერ გადახდებიდან უნდა დაბრუნდეს.',
  'membershipActions.delete.reasonPlaceholder': 'მაგალითად: ორჯერ შეიყვანეს',
  'membershipActions.deleted': 'აბონემენტი წაიშალა',
  'members.addMembership': 'აბონემენტის დამატება: {name}',
  'membershipActions.cancel.label': 'გაუქმება',
  'membershipActions.cancel.title': 'აბონემენტის გაუქმება',
  'membershipActions.cancel.description': 'ამის დაბრუნება შეუძლებელია. წევრის ისტორია შენარჩუნდება.',
  'membershipActions.updated': 'აბონემენტი შეიცვალა',
  'membershipActions.history': 'ისტორია',
  'membershipActions.menu': 'აბონემენტის მოქმედებები',
  'membershipActions.freeze': 'გაყინვა',
  'membershipActions.unfreeze': 'გაყინვის მოხსნა',
  'membershipActions.freezeTitle': 'აბონემენტის გაყინვა',
  'membershipActions.freezeDescription.one': '{plan} · გაყინვები აქამდე: {count}',
  'membershipActions.freezeDescription.other': '{plan} · გაყინვები აქამდე: {count}',
  'membershipActions.freezeFrom': 'დაწყება',
  'membershipActions.freezeUntil': 'დასრულება',
  'membershipActions.freezeReasonDefault': 'წევრის თხოვნით',
  'membershipActions.frozen': 'აბონემენტი გაიყინა',
  'membershipActions.freezeScheduled': 'გაყინვა დაიგეგმა {date}-დან',
  'membershipActions.unfreezeTitle': 'მოვხსნათ გაყინვა?',
  'membershipActions.unfreezeDescription': 'გაყინვა დღეს დასრულდება და გაყინული დღეები დასრულების თარიღს დაემატება.',
  'membershipActions.unfrozen': 'გაყინვა მოიხსნა',
  'membershipActions.historyTitle': 'აბონემენტის ისტორია',
  'membershipActions.noHistory': 'ისტორია ჯერ არ არის',
  'enum.membershipStatus.PAUSED': 'გაყინული',
  'enum.membershipTransition.ACTIVATE': 'გააქტიურება',
  'enum.membershipTransition.RENEW': 'გაგრძელება',
  'enum.membershipTransition.PAUSE': 'გაყინვა',
  'enum.membershipTransition.RESUME': 'გაყინვის მოხსნა',
  'enum.membershipTransition.EXPIRE': 'ვადის გასვლა',
  'enum.membershipTransition.CANCEL': 'გაუქმება',
  'enum.membershipTransition.SUSPEND': 'შეჩერება',
  'enum.membershipTransition.UNSUSPEND': 'შეჩერების მოხსნა',
  'enum.membershipTransition.DELETE': 'წაშლა',
  'enum.membershipTransition.RESTORE': 'აღდგენა',
  'memberPhoto.take': 'ფოტოს გადაღება',
  'memberPhoto.upload': 'ატვირთვა',
  'memberPhoto.takeTitle': 'ფოტოს გადაღება',
  'memberPhoto.takeHint': 'სთხოვეთ წევრს კამერაში ჩაიხედოს. ფოტო ჩანს მიმღებში და ტურნიკეტთან.',
  'memberPhoto.capture': 'გადაღება',
  'memberPhoto.noCamera': 'ამ ბრაუზერს კამერა არ შეუძლია გამოიყენოს. ატვირთეთ ფოტო.',
  'memberPhoto.cameraDenied': 'კამერის გახსნა ვერ მოხერხდა. ბრაუზერში დაუშვით კამერაზე წვდომა ან ატვირთეთ ფოტო.',
  'memberPhoto.saved': 'ფოტო შენახულია',
  'memberPhoto.remove': 'ფოტოს წაშლა',
  'memberPhoto.missing': 'ფოტო ჯერ არ არის',
  'memberPhoto.uploadFailed': 'წევრი შენახულია, მაგრამ ფოტო ვერ აიტვირთა. დაამატეთ წევრის გვერდიდან.',
};
